export var RelationshipTypeEnum;
(function (RelationshipTypeEnum) {
    RelationshipTypeEnum["Partner"] = "Partner";
    RelationshipTypeEnum["Son"] = "Son";
    RelationshipTypeEnum["Daughter"] = "Daughter";
    RelationshipTypeEnum["SonInLaw"] = "SonInLaw";
    RelationshipTypeEnum["DaughterInLaw"] = "DaughterInLaw";
    RelationshipTypeEnum["Grandson"] = "Grandson";
    RelationshipTypeEnum["Granddaughter"] = "Granddaughter";
    RelationshipTypeEnum["Mother"] = "Mother";
    RelationshipTypeEnum["Father"] = "Father";
    RelationshipTypeEnum["Sibling"] = "Sibling";
    RelationshipTypeEnum["Niece"] = "Niece";
    RelationshipTypeEnum["Nephew"] = "Nephew";
    RelationshipTypeEnum["Grandmother"] = "Grandmother";
    RelationshipTypeEnum["Grandfather"] = "Grandfather";
})(RelationshipTypeEnum || (RelationshipTypeEnum = {}));
